import {Component, HostListener, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {QuizService} from "../../services/quiz.service";
import {QuizStatus} from "../../models/quizStatus";
import {Quiz} from "../../models/quiz";
import {QuestionService} from "../../services/question.service";
import {TestConfigRouterUtil} from "./test-config-router-util";
import {TestConfigMenuItem} from "./test-config-item.enum";

@Component({
  selector: 'app-test-configuration',
  templateUrl: './test-configuration.component.html',
  styleUrls: ['./test-configuration.component.css']
})
export class TestConfigurationComponent implements OnInit {

  isTestConfigurationDropdownOpen = true;
  isTestProgressAndResultsDropdownOpen = true;
  hasQuizQuestions: boolean = true;
  isSidebarMenuToggled: boolean = true;
  protected readonly QuizStatus = QuizStatus;
  quizId: string | undefined;
  isMobile: boolean = false;
  quizDataStr: Quiz | undefined;

  constructor(
    private quizService: QuizService,
    private router: Router,
    private route: ActivatedRoute,
    private questionService: QuestionService,
    public testConfigRouter: TestConfigRouterUtil
  ) {
    this.route.queryParams.subscribe(queryParams => {
      this.quizId = queryParams['id'];
      if (this.quizId) {
        this.quizService.getQuizById(this.quizId!).subscribe(quiz => {
          this.quizDataStr = quiz;
        })
      }
    })
  }

  ngOnInit() {
    this.initIsMobile();
  }

  toggleTestConfigurationDropdown() {
    this.isTestConfigurationDropdownOpen = !this.isTestConfigurationDropdownOpen;
  }

  toggleTestProgressAndResultsDropdown() {
    this.isTestProgressAndResultsDropdownOpen = !this.isTestProgressAndResultsDropdownOpen;
  }

  setSidebarMenuToggled(toggled: boolean) {
    this.isSidebarMenuToggled = toggled;
  }

  isButtonDisabled(): boolean {
    return !this.quizId;
  }

  changeQuizStatus(): void {
    if (this.quizDataStr) {
      const oldStatus = this.quizDataStr.status;
      const newStatus = oldStatus === QuizStatus.SETUP_IN_PROGRESS || oldStatus === QuizStatus.ENDED ?
        QuizStatus.ACTIVE : QuizStatus.ENDED;
      if (this.quizId) {
        this.quizService.changeStatus(newStatus, this.quizId).subscribe(_ => {
            if (this.quizDataStr) {
              this.quizDataStr.status = newStatus;
            }
            this.router.navigate(['quiz/results/table'], {queryParams: {id: this.quizId}});
          },
          (error) => {
            console.error("Error:", error);
          })
      }
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.initIsMobile();
  }

  private initIsMobile() {
    const screenWidth = window.innerWidth;
    this.isMobile = screenWidth < 1221;
  }

  getQuizStatus(): QuizStatus | null {
    return this.quizDataStr?.status || null;
  }

  getQuizName(): String | null {
    return this.quizDataStr?.name || null;
  }

  onClickActiveButton() {
    this.questionService.totalCount(this.quizId).subscribe(totalQuestions => {
      this.hasQuizQuestions = !!totalQuestions;
    })
  }

  get getMenuItems() {
    return this.testConfigRouter.getMenuItems;
  }

  navigateToPage(item: TestConfigMenuItem) {
    this.testConfigRouter.navigateToPage(item);
  }

  isRouteActive(item: TestConfigMenuItem): boolean {
    return this.testConfigRouter.isRouteActive(item);
  }
}
